module.exports = __webpack_public_path__ + "img/vertical_4_4_6000.c60a4f79.png";